<!-- Hero Section -->
<header class="bg-primary text-white text-center py-5">
  <div class="container">
    <h1 class="display-4">Our Expert Services</h1>
    <p class="lead">We provide innovative IT solutions to support your business growth and success.</p>
  </div>
</header>

<!-- Services Section -->
<section class="py-5">
  <div class="container">
    <h2 class="text-center text-primary mb-4">Our Core Services</h2>
    <div class="row">
      <!-- Service 1: CCTV Installation -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/structural_cabling.jpg" class="card-img-top" alt="Structural cabling">
          <div class="card-body text-center">
            <i class="bi bi-camera-fill text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">Structural cabling</h5>
            <p class="card-text">ensures a reliable and organized network infrastructure for businesses. It enhances scalability, reduces downtime, and supports high-speed data transmission, making it ideal for offices, data centers, and commercial spaces</p>
            <a href="cctv.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 2: Security System -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/cctv.jpg" class="card-img-top" alt="Security System">
          <div class="card-body text-center">
            <i class="bi bi-antenna-signal text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">Security System</h5>
            <p class="card-text">solutions provide advanced protection for homes and businesses. With CCTV surveillance, access control, and alarm systems, they ensure 24/7 monitoring, threat detection, and enhanced safety.</p>
            <a href="networking.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 3: AV System -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/av.jpg" class="card-img-top" alt="AV System">
          <div class="card-body text-center">
            <i class="bi bi-bar-chart-line text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">AV System</h5>
            <p class="card-text">solutions deliver high-quality audio and visual experiences for businesses, conference rooms, and entertainment spaces. They include smart displays, sound systems, and seamless connectivity for enhanced communication and engagement.</p>
            <a href="marketing.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Service 4: Cloud Services -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/td.jpg" class="card-img-top" alt="Computer Equipment Trading">
          <div class="card-body text-center">
            <i class="bi bi-cloud-arrow-up-fill text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">Computer Equipment Trading</h5>
            <p class="card-text">offers a wide range of IT hardware, including laptops, desktops, servers, and peripherals. We provide high-quality products from leading brands to meet business and personal computing needs.</p>
            <a href="cloud.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 5: IT Consulting -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/bms.jpg" class="card-img-top" alt="BMS">
          <div class="card-body text-center">
            <i class="bi bi-person-circle text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">BMS</h5>
            <p class="card-text">integrates various building functions such as lighting, HVAC, security, and energy management into a unified system. It ensures optimal performance, energy efficiency, and a comfortable environment while reducing operational costs.</p>
            <a href="consulting.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 6: Website Development -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/ups.jpg" class="card-img-top" alt="UPS">
          <div class="card-body text-center">
            <i class="bi bi-laptop text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">UPS </h5>
            <p class="card-text">(Mechanical, Electrical, and Plumbing) solutions ensure efficient building infrastructure by integrating HVAC, electrical systems, and plumbing. They enhance energy efficiency, safety, and sustainability for residential, commercial, and industrial projects.</p>
            <a href="webdevelopment.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Service 4: Cloud Services -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/mep.jpg" class="card-img-top" alt="MEP">
          <div class="card-body text-center">
            <i class="bi bi-cloud-arrow-up-fill text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">MEP</h5>
            <p class="card-text">(Mechanical, Electrical, and Plumbing) solutions ensure efficient building infrastructure by integrating HVAC, electrical systems, and plumbing. They enhance energy efficiency, safety, and sustainability for residential, commercial, and industrial projects.</p>
            <a href="cloud.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 5: IT Consulting -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/hvac.jpg" class="card-img-top" alt="HVAC">

          <div class="card-body text-center">
            <i class="bi bi-person-circle text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">HVAC</h5>
            <p class="card-text">(Heating, Ventilation, and Air Conditioning) systems provide efficient climate control, ensuring optimal indoor air quality and comfort. They enhance energy efficiency, regulate temperature, and improve air circulation for residential, commercial, and industrial spaces.</p>
            <a href="consulting.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
      <!-- Service 6: Website Development -->
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm">
          <img src="assets/img/Services/HOME_AUTOMATION.png" class="card-img-top" alt="HOME AUTOMATION">

          <div class="card-body text-center">
            <i class="bi bi-laptop text-primary" style="font-size: 3rem;"></i>
            <h5 class="card-title mt-3">HOME AUTOMATION</h5>
            <p class="card-text">enhances convenience, security, and energy efficiency by integrating smart lighting, climate control, security systems, and entertainment. It allows remote control and automation of home devices for a seamless, modern living experience.</p>
            <a href="webdevelopment.html" class="btn btn-outline-primary">Learn More</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<section class="py-5 bg-light">
  <div class="container">
    <h2 class="text-center fw-bold mb-4">Why Choose Us</h2>
    <p class="text-center mb-5">We are committed to delivering exceptional services that set us apart in the industry. Here’s why our clients trust us:</p>
    <div class="row g-4">
      <!-- Feature 1: Quality Products -->
      <div class="col-md-6 col-lg-4 text-center">
        <div class="p-4 shadow-sm bg-white rounded">
          <i class="fas fa-gem fa-3x text-primary mb-3"></i>
          <h5 class="fw-bold">Quality Products</h5>
          <p class="text-muted">We deliver only the highest-quality products to meet your business needs.</p>
        </div>
      </div>
      <!-- Feature 2: Reliable Services -->
      <div class="col-md-6 col-lg-4 text-center">
        <div class="p-4 shadow-sm bg-white rounded">
          <i class="fas fa-check-circle fa-3x text-success mb-3"></i>
          <h5 class="fw-bold">Reliable Services</h5>
          <p class="text-muted">Dependable support and services to ensure your success.</p>
        </div>
      </div>
      <!-- Feature 3: Innovation -->
      <div class="col-md-6 col-lg-4 text-center">
        <div class="p-4 shadow-sm bg-white rounded">
          <i class="fas fa-lightbulb fa-3x text-warning mb-3"></i>
          <h5 class="fw-bold">Innovation</h5>
          <p class="text-muted">Creative and forward-thinking solutions tailored to your needs.</p>
        </div>
      </div>
      <!-- Feature 4: Cost-Effective Solutions -->
      <div class="col-md-6 col-lg-6 text-center">
        <div class="p-4 shadow-sm bg-white rounded">
          <i class="fas fa-dollar-sign fa-3x text-info mb-3"></i>
          <h5 class="fw-bold">Cost-Effective Solutions</h5>
          <p class="text-muted">Affordable options without compromising on quality or reliability.</p>
        </div>
      </div>
      <!-- Feature 5: Client Satisfaction -->
      <div class="col-md-6 col-lg-6 text-center">
        <div class="p-4 shadow-sm bg-white rounded">
          <i class="fas fa-smile fa-3x text-danger mb-3"></i>
          <h5 class="fw-bold">Client Satisfaction</h5>
          <p class="text-muted">Our top priority is ensuring you are completely satisfied.</p>
        </div>
      </div>
    </div>
  </div>
</section>
